import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import announcer from './aria-announcer';

const nextElement = 'Next element';
const prevElement = 'Previous element';
const getAdjacentSlidesLabels = (el) => {
    const prevSlide = el.querySelector('.swiper-slide-prev');
    const nextSlide = el.querySelector('.swiper-slide-next');
    const prevLabel = prevSlide?.getAttribute('aria-label');
    const nextLabel = nextSlide?.getAttribute('aria-label');
    return { prevLabel, nextLabel };
};

document.addEventListener('DOMContentLoaded', () => {
    const $blockImageSwiper = document.querySelectorAll('.block-img-swiper');
    const updateSlideAccessibility = ({ slides, activeIndex }) => {
        slides.forEach((slide, index) => {
            const isActive = index === activeIndex;
            slide.setAttribute('tabindex', isActive ? '0' : '-1');
            slide.setAttribute('aria-hidden', (!isActive).toString());
        });
    };

    $blockImageSwiper.forEach((el) => {
        const btnPrev = el.querySelector('.swiper-nav-prev');
        const btnNext = el.querySelector('.swiper-nav-next');

        // eslint-disable-next-line no-new
        new Swiper(el, {
            modules: [Navigation, Pagination, A11y],
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 8,
            loop: true,
            navigation: {
                nextEl: btnNext,
                prevEl: btnPrev,
            },
            pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
            },
            on: {
                init: (element) => {
                    updateSlideAccessibility(element);
                },
                slideChangeTransitionEnd: (element) => {
                    updateSlideAccessibility(element);
                },
            },
            a11y: {
                enabled: true,
                containerRole: 'group',
                containerRoleDescriptionMessage: 'carousel',
                containerMessage: 'Images',
                prevSlideMessage: prevElement,
                nextSlideMessage: nextElement,
                paginationBulletMessage: 'Go to image {{index}}',
            },
        });

        btnNext.addEventListener('click', () => {
            const { nextLabel } = getAdjacentSlidesLabels(el);
            announcer.announce(`Next image ${nextLabel}`);
        });

        btnPrev.addEventListener('click', () => {
            const { prevLabel } = getAdjacentSlidesLabels(el);
            announcer.announce(`Previous image ${prevLabel}`);
        });
    });

    // Block quote swiper
    const $blockQuoteSwiper = document.querySelectorAll('.block-quote-carousel');

    $blockQuoteSwiper.forEach((el) => {
        const btnPrev = el.querySelector('.swiper-nav-prev');
        const btnNext = el.querySelector('.swiper-nav-next');

        if (!btnNext || !btnPrev) return;

        // eslint-disable-next-line no-new
        new Swiper(el, {
            modules: [Navigation, Pagination, A11y],
            slidesPerView: 1,
            spaceBetween: 40,
            navigation: {
                nextEl: btnNext,
                prevEl: btnPrev,
            },
            pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
            },
            on: {
                init: (element) => {
                    updateSlideAccessibility(element);
                },
                slideChangeTransitionEnd: (element) => {
                    updateSlideAccessibility(element);
                },
            },
            a11y: {
                enabled: true,
                containerRole: 'group',
                containerRoleDescriptionMessage: 'carousel',
                containerMessage: 'Quotes',
                prevSlideMessage: 'Previous quote',
                nextSlideMessage: 'Next quote',
                paginationBulletMessage: 'Go to quote {{index}}',
            },
        });

        btnNext.addEventListener('click', () => {
            const { nextLabel } = getAdjacentSlidesLabels(el);
            announcer.announce(`Next quote ${nextLabel}`);
        });

        btnPrev.addEventListener('click', () => {
            const { prevLabel } = getAdjacentSlidesLabels(el);
            announcer.announce(`Previous quote ${prevLabel}`);
        });
    });

    // Home case studies swiper (mobile only)
    const $caseStudiesSwiper = document.querySelectorAll('.home-case-studies-swiper');

    $caseStudiesSwiper.forEach((el) => {
        let init = false;

        function initSwiper() {
            if (window.innerWidth < 1024) {
                if (!init) {
                    init = true;
                    // eslint-disable-next-line no-new
                    new Swiper(el, {
                        modules: [Pagination, A11y],
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                        pagination: {
                            el: el.querySelector('.swiper-pagination'),
                            clickable: true,
                        },
                        on: {
                            init: (element) => {
                                updateSlideAccessibility(element);
                            },
                            slideChangeTransitionEnd: (element) => {
                                updateSlideAccessibility(element);
                            },
                        },
                        a11y: {
                            enabled: true,
                            containerRole: 'group',
                            containerRoleDescriptionMessage: 'carousel',
                            containerMessage: 'Case study',
                            paginationBulletMessage: 'Go to slide {{index}}',
                        },
                    });
                }
            } else if (init) {
                el.swiper.destroy(true, true);
                init = false;
            }
        }

        initSwiper();
        window.addEventListener('resize', initSwiper);
    });

    const $blockNewsSwiper = document.querySelectorAll('.block-news-listing .swiper');

    $blockNewsSwiper.forEach((el) => {
        const btnPrev = el.querySelector('.button-swiper-prev');
        const btnNext = el.querySelector('.button-swiper-next');
        let init = false;

        function initSwiper() {
            if (window.innerWidth < 768) {
                if (!init) {
                    init = true;
                    // eslint-disable-next-line no-new
                    new Swiper(el, {
                        modules: [Navigation, Pagination, A11y],
                        slidesPerView: 1,
                        spaceBetween: 24,
                        loop: true,
                        navigation: {
                            nextEl: btnNext,
                            prevEl: btnPrev,
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true,
                        },
                        on: {
                            init: (element) => {
                                updateSlideAccessibility(element);
                            },
                            slideChangeTransitionEnd: (element) => {
                                updateSlideAccessibility(element);
                            },
                        },
                        a11y: {
                            enabled: true,
                            containerRole: 'group',
                            containerRoleDescriptionMessage: 'carousel',
                            containerMessage: 'News',
                            prevSlideMessage: prevElement,
                            nextSlideMessage: nextElement,
                            paginationBulletMessage: 'Go to element {{index}}',
                        },
                    });
                }
            } else if (init) {
                el.swiper.destroy(true, true);
                init = false;
            }
        }

        initSwiper();
        window.addEventListener('resize', initSwiper);

        btnNext.addEventListener('click', () => {
            const { nextLabel } = getAdjacentSlidesLabels(el);
            announcer.announce(`Next element ${nextLabel}`);
        });

        btnPrev.addEventListener('click', () => {
            const { prevLabel } = getAdjacentSlidesLabels(el);
            announcer.announce(`Previous element ${prevLabel}`);
        });
    });
});
